export default "__VITE_ASSET__1c96656a__"